module.exports = require("@mui/material/styles/styled");